import React, { useEffect, useState } from "react";
import SmallScreenSidebar from "../SmallScreenSidebar";
import { AiOutlineBars, AiFillDelete } from "react-icons/ai";
import { FaEdit } from "react-icons/fa";
import AdminSkeleton from "../AdminSkeleton/AdminSkeleton";
import DeletePopUp from "../DeletePopUp/DeletePopUp";
import { MyContextSupply } from "../../../Context";
import axios from "axios";
import { toast } from "react-toastify";
import AdminUpdateItem from "./UpdateProduct/AdminUpdateItem";

const AdminItemList = () => {
  const { setIsAdminSidebarOpen, token } = MyContextSupply();
  const [getProducts, setProducts] = useState([]);
  const [isProductLoading, setIsProductLoading] = useState(false);
  const [isClickedToDelete, setIsClickedToDelete] = useState(false);
  const [productId, setProductId] = useState(null);
  const [runDelete, setRunDelete] = useState(0);
  const [isUpdatingProducts, setIsUpdatingProducts] = useState(false);
  const [updatingData, setUpdatingData] = useState('');
  console.log(getProducts);

  const toastStyle = {
    position: "top-center",
    autoClose: 2000,
  };

  const getAllProducts = async () => {
    setIsProductLoading(true);
    await axios
      .get("https://stechbackend-9r4c.onrender.com/getproducts")
      .then((res) => {
        if (res.status === 201) {
          setProducts(res.data);
          setIsProductLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const OnClickDeleteProduct = async (id) => {
    await axios
      .delete(
        `https://stechbackend-9r4c.onrender.com/admin/product/delete/${id}`,
        { headers: { Authorization: token }, withCredentials: true }
      )
      .then((res) => {
        if (res.status === 201) {
          setRunDelete(runDelete + 1);
          toast.success(res.data.message, toastStyle);
        }
      })
      .catch((error) => {
        const status = error.response.status;
        const message = error.response.data.message;
        if (status === 404) {
          toast.warn(message, toastStyle);
        } else if (status === 422) {
          toast.warn(message, toastStyle);
        } else if (status === 500) {
          toast.warn(message, toastStyle);
        } else {
          toast.warn(message, toastStyle);
        }
      });
  };
  useEffect(() => {
    getAllProducts();
  }, [runDelete]);
  return (
    <section className="main-prod">
      <SmallScreenSidebar />
      <button
        onClick={() => setIsAdminSidebarOpen(true)}
        className="smallsidebar-open-btn"
      >
        <AiOutlineBars />
      </button>
      <div className="deshboard-content-part">
        <h1>All Products Info</h1>
        {isProductLoading ? (
          <AdminSkeleton />
        ) : (
          <section className="desh-main-display desh-main-display-product-list">
            <article className="table-article-user">
              {getProducts?.length === 0 ? (
                <h1 className="productlist-length-zero">
                  Still no product added to website, nothing to display
                  here......
                </h1>
              ) : (
                <>
                  <h1>Manage All the Products</h1>
                  <table border="1" style={{ color: "white" }}>
                    <thead>
                      <tr
                        className="admin-item-list-table"
                        style={{
                          background: "white",
                          color: "black",
                          fontWeight: "bolder",
                        }}
                      >
                        <td>Index</td>
                        <td>Product ID</td>
                        <td>Product Name</td>
                        <td>Price($)</td>
                        <td>Update Product</td>
                        <td>Delete Product</td>
                      </tr>
                    </thead>
                    <tbody>
                      {getProducts.length !== 0 &&
                        getProducts &&
                        getProducts.map((product, index) => {
                          const {
                            _id: id,
                            price,
                            title,
                          } = product;
                          const { cost } = price !== undefined && price;
                          const {shortTitle} = title && title;
                          return (
                            <tr className="admin-item-list-table" key={id}>
                              <td>{index + 1}</td>
                              <td>{id}</td>
                              <td>{shortTitle}</td>
                              <td>{cost}</td>
                              <td>
                                <FaEdit onClick={() => {
                                  setUpdatingData(product);
                                  setIsUpdatingProducts(true);
                                }} className="delete-btn-admin-product-others" />
                              </td>
                              <td>
                                <AiFillDelete
                                  onClick={() => {
                                    setIsClickedToDelete(true);
                                    setProductId(id);
                                  }}
                                  className="delete-btn-admin-product-others deleteAni"
                                />
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                  <DeletePopUp
                    isClickedToDelete={isClickedToDelete}
                    setIsClickedToDelete={setIsClickedToDelete}
                    onClickDelete={OnClickDeleteProduct}
                    id={productId}
                    title="product"
                  />
                </>
              )}
            </article>
          </section>
        )}
      </div>
      <div
        className={`${
          isUpdatingProducts
            ? "update-product-fixed-form show-update-product-fixed-form "
            : "update-product-fixed-form"
        }`}
      >
        <div style={{ overflowY: "auto", height: "100%" }}>
          <AdminUpdateItem isUpdatingProducts={isUpdatingProducts} setIsUpdatingProducts={setIsUpdatingProducts} updatingData={updatingData} setRunDelete={setRunDelete}/>
        </div>
      </div>
    </section>
  );
};

export default AdminItemList;
